import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-barcode-printer',
  templateUrl: './barcode-printer.component.html',
  styleUrls: ['./barcode-printer.component.scss']
})
export class BarcodePrinterComponent implements OnInit {

  @Input()  printcodes: any[] = [];
  @Input()  isMultiple:boolean = false;

  elementType = 'svg';
  value = 'someValue12340987';
  format = 'CODE128';
  lineColor = '#000000';
  width = 0.4;
  height = 18; 
  swidth = 1; //small label without content
  sheight = 12; //small label without content
  bwidth = 1; //big label without content
  bheight = 22; //big label without content
  displayValue = true;
  fontOptions = '';
  font = 'monospace';
  textAlign = 'start';
  textPosition = 'bottom';
  textMargin = 2;
  fontSize = 10;
  sfontSize = 11;
  background = '#ffffff';
  margin = 3;
  marginTop = 4;
  marginBottom = 3;
  marginLeft = 4;
  marginRight = 4;
  smarginLeft = 4;
  smarginRight = 4;
  bmarginLeft = 3;
  bmarginRight = 3;
  smargin = 1;
  bmargin = 2;
  smarginTop = 1;
  smarginBottom = 1;
  bmarginTop = 10;
  bmarginBottom = 10;
 
  //marginBottom1 = 180;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes:SimpleChanges){
    if (changes?.printcodes?.currentValue != changes?.printcodes?.previousValue) {    
       this.printcodes = changes?.printcodes?.currentValue;
       this.isMultiple = changes?.isMultiple?.currentValue;
    }
  
  }

}
